import React from 'react';

import './StatusSummaryTable.scss';

class StatusSummaryTableRow extends React.Component {

  render() {
    const { rowLabel, rowValue } = this.props;
    return (
      <tr className="parkchirp--status-summary-table-row">
        <td className="parkchirp--status-summary-table-row-label"><span>{rowLabel}</span></td>
        <td className="parkchirp--status-summary-table-row-value"><span>{rowValue}</span></td>
      </tr>
    );
  }
}

export default StatusSummaryTableRow;
